import { recorderFmc } from '@/tauri/controller/recording';
import { logger } from '@/utils/logger/logger';
import { bridgeErrorKind } from '@heidi/plugin-core';
import { sanitizeError } from '@heidi/runtime/logger';
import { pTimeout } from '@heidi/utils';
import { isPTimeoutRejection } from './useMutateStartTauriRecording.constants';

const SETTLE_TIMEOUT_MS = 10_000;

/**
 * Tells Rust the FE uploaded this recording's backup itself, so its durable row is not retried or offered
 * again. Best effort and bounded: a failure is logged and never reaches the upload that succeeded, and a row
 * that comes back not `uploaded` (a native attempt owns it) is logged too.
 */
export async function settleNativeBackupRow(
  sessionId: string,
  recordingId: string
): Promise<void> {
  try {
    const row = await pTimeout(
      recorderFmc.onlineBackupMarkUploaded({ sessionId, recordingId }),
      SETTLE_TIMEOUT_MS
    );
    if (row.status === 'uploaded') {
      logger.info('[BackupUpload] native backup row settled', {
        sessionId,
        status: row.status,
      });
    } else {
      logger.warn('[BackupUpload] native backup row not settled', {
        sessionId,
        status: row.status,
      });
    }
  } catch (error) {
    logger.warn('[BackupUpload] could not settle the native backup row', {
      sessionId,
      errorKind: isPTimeoutRejection(error) ? 'timeout' : bridgeErrorKind(error),
      error: sanitizeError(error),
    });
  }
}
